import React, { useState, useEffect } from "react";
import {
  IUniformPayment,
  ICreateUniformPayment,
} from "../../interfaces/IUniformPayment";

interface UniformPaymentFormProps {
  partnerId?: number;
  applicationId?: number;
  totalAmount: number;
  onPaymentChange: (payment: ICreateUniformPayment | null) => void;
  initialPayment?: IUniformPayment;
}

const UniformPaymentForm: React.FC<UniformPaymentFormProps> = ({
  partnerId,
  applicationId,
  totalAmount,
  onPaymentChange,
  initialPayment,
}) => {
  const [mustPay, setMustPay] = useState(initialPayment?.mustPay || false);
  const [installments, setInstallments] = useState(
    initialPayment?.installments || 1
  );

  const lastEmittedRef = React.useRef<string>("");

  useEffect(() => {
    console.log("UniformPaymentForm useEffect:", { mustPay, totalAmount, installments, partnerId });
    if (mustPay && totalAmount > 0) {
      const payment: ICreateUniformPayment = {
        partnerId,
        applicationId,
        mustPay: true,
        installments,
        totalAmount,
        amountPerFortnight: totalAmount / (installments || 1),
        totalUnitAmount: totalAmount,
        currentFortnight: 0,
      };
      const serialized = JSON.stringify(payment);
      if (serialized !== lastEmittedRef.current) {
        lastEmittedRef.current = serialized;
        console.log("Sending payment data:", payment);
        onPaymentChange(payment);
      }
    } else {
      if (lastEmittedRef.current !== "null") {
        lastEmittedRef.current = "null";
        console.log("No payment to send");
        onPaymentChange(null);
      }
    }
  }, [mustPay, installments, totalAmount, partnerId]);

  const installmentOptions = Array.from({ length: 10 }, (_, i) => i + 1);

  return (
    <div className="card border-0 bg-light">
      <div className="card-body p-3">
        <h6 className="card-title mb-3 text-dark">
          <i className="fas fa-credit-card me-2"></i>
          Pago de Uniformes
        </h6>

        <div className="row">
          <div className="col-md-6">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="mustPay"
                checked={mustPay}
                onChange={(e) => setMustPay(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="mustPay">
                <strong>El colaborador pagará sus uniformes</strong>
              </label>
            </div>
          </div>

          {mustPay && (
            <div className="col-md-6">
              <label htmlFor="installments" className="form-label">
                <strong>Número de quincenas:</strong>
              </label>
              <select
                className="form-select"
                id="installments"
                value={installments}
                onChange={(e) => setInstallments(Number(e.target.value))}
              >
                {installmentOptions.map((num) => (
                  <option key={num} value={num}>
                    {num} quincena{num > 1 ? "s" : ""}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        {mustPay && totalAmount > 0 && (
          <div className="mt-3 pt-3 border-top">
            <div className="row">
              <div className="col-md-4">
                <small className="text-muted">Total a pagar:</small>
                <div className="fw-bold text-primary">
                  ${totalAmount.toFixed(2)}
                </div>
              </div>
              <div className="col-md-4">
                <small className="text-muted">Pago por quincena:</small>
                <div className="fw-bold text-success">
                  ${(totalAmount / installments).toFixed(2)}
                </div>
              </div>
              <div className="col-md-4">
                <small className="text-muted">Duración:</small>
                <div className="fw-bold text-info">
                  {installments} quincena{installments > 1 ? "s" : ""}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UniformPaymentForm;
